import classNames from 'classnames'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'

export const renderDecoratedTitle = (text, params) => {
    const {
        style,
        className,
        isRequired = false,
        withLabel = () => {},
    } = params || {}
    return (
        <Translate>
            {(t) => (
                <label
                    style={style}
                    className={classNames(
                        'text-lg font-normal text-color-100 uppercase tracking-wider',
                        className,
                        isRequired && 'required-label'
                    )}
                    {...withLabel({
                        className,
                        isRequired,
                    })}>
                    {t(text)}
                </label>
            )}
        </Translate>
    )
}


export const renderDecoratedLabel = (text, params) => {
    const {
        style,
        className,
        isRequired = false,
        withLabel = () => {},
    } = params || {}
    return (
        <Translate>
            {(t) => (
                <label
                    style={style}
                    className={classNames(
                        'text-xs font-medium text-color-200 tracking-wider',
                        className,
                        isRequired && 'required-label'
                    )}
                    {...withLabel({
                        className,
                        isRequired,
                    })}>
                    {t(text)}
                </label>
            )}
        </Translate>
    )
}

const FieldDecorator = ({
                            className,
                            label,
                            description,
                            errors,
                            children,
                            isRequired = false,
                            hasError = true,
                            labelProps,
                            renderLabel = renderDecoratedLabel,
                        }) => {
    const t = useTranslate()
    return (
        <div
            className={classNames(
                'ErrorDescription relative flex flex-col space-y-1',
                isRequired && 'required-field',
                {errors},
                className
            )}>

            {_.isString(label) ? (
                    renderLabel(label, {
                        isRequired,
                        className: 'flex capitalize text-sm font-semibold pb-2 block text-color-100',
                        ...(labelProps ?? {}),
                    })
            ) : label}

            {children}

            {_.isString(description) ? (
                <label style={{marginTop: 4, fontSize: 11}} className="text-2xs block text-color-400 italic leading-tight whitespace-pre-line">
                    {t(description)}
                </label>
            ) : description}

            <div
                style={{marginTop: 4, fontSize: 11}}
                className={classNames(
                    'ml-1 text-rose-600 italic error-message',
                    hasError && !!_.get(errors, 'message', errors) && 'error-message-show'
                )}>
                {_.get(errors, 'message', errors)}
            </div>

            {/*{!!_.get(errors, 'message', errors) && (*/}
            {/*    <div*/}
            {/*        style={{ marginTop: 4, fontSize: 11}}*/}
            {/*        className={classNames("ml-1 text-red-500 italic", hasError ? 'error-message-show' : 'error-message')}>*/}
            {/*        {_.get(errors, 'message', errors)}*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    )
}

export const FormFieldWrapper = (props) => (
    <FieldDecorator
        labelProps={{
            style: {padding: 0},
        }}
        {...props}
    />
)

export default FieldDecorator
